<template>
<section class="bg-white py-3 border-t border-border">
    <div class="container-fluid text-center">
        <p class="content !m-0 !text-blackPrimary">© Copyright 2018 - 2024 U.S. Legal Services</p>
    </div>
</section>

</template>